import { Component, inject, Input, OnInit } from "@angular/core";
import { Auth } from "@angular/fire/auth";
import { Router } from "@angular/router";
import { StorageKeys } from "src/app/consts/storage-keys";
import { ForumRef } from "src/app/enums/forum-from-ref.enum";
import { UserService } from "src/app/services/user/user.service";

@Component({
	selector: "app-header",
	templateUrl: "./header.component.html",
	styleUrls: ["./header.component.scss"],
})
export class HeaderComponent implements OnInit {
	private auth = inject(Auth);

	isLogin: boolean = false;
	@Input("brands") brands: any;

	userPersonalDetails: any;
	cartItemsCount = 0;
	myAccountItems = [
		{
			label: "Profile & Settings",
			icon: "person",
			routerLink: "/settings",
		},
		{
			label: "Orders",
			icon: "history",
			routerLink: "/order-history",
		},
		{
			label: "Sign Out",
			icon: "logout",
			command: () => {
				this.signOut();
			},
		},
	];

	constructor(public userService: UserService, private router: Router) {}

	get ForumRef() {
		return ForumRef;
	}

	ngOnInit(): void {
		this.isLogin = this.userService.isLogIn;
		if (this.userService.isLogIn) {
			this.userPersonalDetails = this.userService.userData.user_data;
		}
		this.userService.onUserLoginStatusChange.subscribe((userData: any) => {
			if (userData) {
				this.isLogin = true;
				this.userPersonalDetails = userData.user_data;
			}
		});

		this.userService.onCartUpdate.subscribe(() => {
			this.refreshCartCount();
		});
		this.refreshCartCount();
	}

	ngAfterViewInit() {}

	openSideMenu() {
		document.querySelector("nav#mobile-nav")?.classList.add("mobile-nav-active");
		document.querySelector("nav#mobile-nav")?.classList.remove("mobile-nav-inactive");
	}

	closeSideMenu() {
		document.querySelector("nav#mobile-nav")?.classList.add("mobile-nav-inactive");
		document.querySelector("nav#mobile-nav")?.classList.remove("mobile-nav-active");
	}

	signOut() {
		this.isLogin = false;
		this.userService.isLogIn = false;
		this.userService.userData = null;
		localStorage.clear();
		sessionStorage.clear();
		this.refreshCartCount();
		this.auth.signOut();
		this.router.navigate(["/"], {
			replaceUrl: true,
		});
	}

	refreshCartCount() {
		const _cart = localStorage.getItem(StorageKeys.CART);
		if (_cart) {
			const cartDataParsed = JSON.parse(_cart);
			this.cartItemsCount = cartDataParsed.length;
		} else {
			this.cartItemsCount = 0;
		}
	}
}
